(() => {
  angular
    .module('gm.common.currency')
    .constant('Continents', [
      'Africa',
      'Americas',
      'Asia Pacific',
      'Europe'
    ])
    .constant('Currencies', [{
      code: 'GAU',
      sign: '',
      flag: 'gold',
      post: ' GAU',
      name: 'Gold Gram',
      top: 100,
      countries: []
    },
    {
      code: 'DZD',
      sign: 'دج',
      flag: 'dz',
      post: '',
      name: 'Algerian Dinar',
      countries: [{
        name: 'Algeria',
        flag: 'dz',
        continent: 0
      }]
    },
    {
      code: 'AOA',
      sign: 'Kz',
      flag: 'ao',
      post: '',
      name: 'Kwanza',
      countries: [{
        name: 'Angola',
        flag: 'ao',
        continent: 0
      }]
    },
    {
      code: 'XOF',
      sign: 'CFA',
      flag: 'sn',
      post: '',
      name: 'West African CFA Franc',
      countries: [{
        name: 'Benin',
        flag: 'bj',
        continent: 0
      },
      {
        name: 'Burkina Faso',
        flag: 'bf',
        continent: 0
      },
      {
        name: 'Cote d\'Ivoire',
        flag: 'ci',
        continent: 0
      },
      {
        name: 'Mali',
        flag: 'ml',
        continent: 0
      },
      {
        name: 'Niger',
        flag: 'ne',
        continent: 0
      },
      {
        name: 'Senegal',
        flag: 'sn',
        continent: 0
      },
      {
        name: 'Togo',
        flag: 'tg',
        continent: 0
      }]
    },
    {
      code: 'BWP',
      sign: 'P',
      flag: 'bw',
      post: '',
      name: 'Pula',
      countries: [{
        name: 'Botswana',
        flag: 'bw',
        continent: 0
      }]
    },
    {
      code: 'BIF',
      sign: 'FBu',
      flag: 'bi',
      post: '',
      name: 'Burundi Franc',
      countries: [{
        name: 'Burundi',
        flag: 'bi',
        continent: 0
      }]
    },
    {
      code: 'XAF',
      sign: 'FCFA',
      flag: 'cm',
      post: '',
      name: 'Central African CFA Franc',
      countries: [{
        name: 'Cameroon',
        flag: 'cm',
        continent: 0
      },
      {
        name: 'Chad',
        flag: 'td',
        continent: 0
      },
      {
        name: 'Gabon Republic',
        flag: 'ga',
        continent: 0
      },
      {
        name: 'Guinea-Bissau',
        flag: 'gw',
        continent: 0
      },
      {
        name: 'Republic of the Congo',
        flag: 'cg',
        continent: 0
      }]
    },
    {
      code: 'CVE',
      sign: '$',
      flag: 'cv',
      post: '',
      name: 'Cabo Verde Escudo',
      countries: [{
        name: 'Cape Verde',
        flag: 'cv',
        continent: 0
      }]
    },
    {
      code: 'KMF',
      sign: 'CF',
      flag: 'km',
      post: '',
      name: 'Comoro Franc',
      countries: [{
        name: 'Comoros',
        flag: 'km',
        continent: 0
      }]
    },
    {
      code: 'CDF',
      sign: 'FC',
      flag: 'cd',
      post: '',
      name: 'Congolese Franc',
      countries: [{
        name: 'Democratic Republic of the Congo',
        flag: 'cd',
        continent: 0
      }]
    },
    {
      code: 'DJF',
      sign: 'Fdj',
      flag: 'dj',
      post: '',
      countries: [{
        name: 'Djibouti',
        flag: 'dj',
        continent: 0
      }],
      name: 'Djibouti Franc'
    },
    {
      code: 'EGP',
      sign: '£',
      flag: 'eg',
      post: '',
      countries: [{
        name: 'Egypt',
        flag: 'eg',
        continent: 0
      }],
      name: 'Egyptian Pound'
    },
    {
      code: 'ERN',
      sign: 'ናቕፋ',
      flag: 'er',
      post: '',
      countries: [{
        name: 'Eritrea',
        flag: 'er',
        continent: 0
      }],
      name: 'Nakfa'
    },
    {
      code: 'ETB',
      sign: 'ብር',
      flag: 'et',
      post: '',
      countries: [{
        name: 'Ethiopia',
        flag: 'et',
        continent: 0
      }],
      name: 'Ethiopian Birr'
    },
    {
      code: 'GMD',
      sign: 'D',
      flag: 'gm',
      post: '',
      countries: [{
        name: 'Gambia',
        flag: 'gm',
        continent: 0
      }],
      name: 'Dalasi'
    },
    {
      code: 'GHS',
      sign: '¢',
      flag: 'gh',
      post: '',
      countries: [{
        name: 'Ghana',
        flag: 'gh',
        continent: 0
      }],
      name: 'Ghana Cedi'
    },
    {
      code: 'GNF',
      sign: 'GF',
      flag: 'gn',
      post: '',
      countries: [{
        name: 'Guinea',
        flag: 'gn',
        continent: 0
      }],
      name: 'Guinea Franc'
    },
    {
      code: 'KES',
      sign: 'KSh',
      flag: 'ke',
      post: '',
      countries: [{
        name: 'Kenya',
        flag: 'ke',
        continent: 0
      }],
      name: 'Kenyan Shilling'
    },
    {
      code: 'LSL',
      sign: 'L',
      flag: 'ls',
      post: '',
      countries: [{
        name: 'Lesotho',
        flag: 'ls',
        continent: 0
      }],
      name: 'Loti'
    },
    {
      code: 'MGA',
      sign: 'Ar',
      flag: 'mg',
      post: '',
      countries: [{
        name: 'Madagascar',
        flag: 'mg',
        continent: 0
      }],
      name: 'Malagasy Ariary'
    },
    {
      code: 'MWK',
      sign: 'MK',
      flag: 'mw',
      post: '',
      countries: [{
        name: 'Malawi',
        flag: 'mw',
        continent: 0
      }],
      name: 'Kwacha'
    },
    {
      code: 'MRO',
      sign: 'UM',
      flag: 'mr',
      post: '',
      countries: [{
        name: 'Mauritania',
        flag: 'mr',
        continent: 0
      }],
      name: 'Ouguiya'
    },
    {
      code: 'MUR',
      sign: '₨',
      flag: 'mu',
      post: '',
      countries: [{
        name: 'Mauritius',
        flag: 'mu',
        continent: 0
      }],
      name: 'Mauritius Rupee'
    },
    {
      code: 'EUR',
      sign: '€',
      flag: 'eu',
      post: '',
      top: 11,
      name: 'Euro',
      countries: [{
        name: 'Belgium',
        flag: 'be',
        continent: 3
      },
      {
        name: 'Mayotte',
        flag: 'yt',
        continent: 0
      },
      {
        name: 'Reunion',
        flag: 'fr',
        continent: 0
      },
      {
        name: 'French Guiana',
        flag: 'gf',
        continent: 1
      },
      {
        name: 'Guadeloupe',
        flag: 'gp',
        continent: 1
      },
      {
        name: 'Martinique',
        flag: 'mq',
        continent: 1
      },
      {
        name: 'Andorra',
        flag: 'ad',
        continent: 3
      },
      {
        name: 'Austria',
        flag: 'at',
        continent: 3
      },
      {
        name: 'Cyprus',
        flag: 'cy',
        continent: 3
      },
      {
        name: 'Estonia',
        flag: 'ee',
        continent: 3
      },
      {
        name: 'France',
        flag: 'fr',
        continent: 3
      },
      {
        name: 'Finland',
        flag: 'fi',
        continent: 3
      },
      {
        name: 'Germany',
        flag: 'de',
        continent: 3
      },
      {
        name: 'Greece',
        flag: 'gr',
        continent: 3
      },
      {
        name: 'Ireland',
        flag: 'ie',
        continent: 3
      },
      {
        name: 'Italy',
        flag: 'it',
        continent: 3
      },
      {
        name: 'Latvia',
        flag: 'lv',
        continent: 3
      },
      {
        name: 'Lithuania',
        flag: 'lt',
        continent: 3
      },
      {
        name: 'Luxembourg',
        flag: 'lu',
        continent: 3
      },
      {
        name: 'Malta',
        flag: 'mt',
        continent: 3
      },
      {
        name: 'Monaco',
        flag: 'mc',
        continent: 3
      },
      {
        name: 'Montenegro',
        flag: 'me',
        continent: 3
      },
      {
        name: 'Netherlands',
        flag: 'nl',
        continent: 3
      },
      {
        name: 'Portugal',
        flag: 'pt',
        continent: 3
      },
      {
        name: 'San Marino',
        flag: 'sm',
        continent: 3
      },
      {
        name: 'Slovakia',
        flag: 'sk',
        continent: 3
      },
      {
        name: 'Slovenia',
        flag: 'si',
        continent: 3
      },
      {
        name: 'Spain',
        flag: 'es',
        continent: 3
      },
      {
        name: 'Vatican City',
        flag: 'va',
        continent: 3
      }]
    },
    {
      code: 'MAD',
      sign: 'د.م.',
      flag: 'ma',
      post: '',
      countries: [{
        name: 'Morocco',
        flag: 'ma',
        continent: 0
      }],
      name: 'Moroccan Dirham'
    },
    {
      code: 'MZN',
      sign: 'MT',
      flag: 'mz',
      post: '',
      countries: [{
        name: 'Mozambique',
        flag: 'mz',
        continent: 0
      }],
      name: 'Mozambique Metical'
    },
    {
      code: 'NAD',
      sign: '$',
      flag: 'na',
      post: '',
      countries: [{
        name: 'Namibia',
        flag: 'na',
        continent: 0
      }],
      name: 'Namibia Dollar'
    },
    {
      code: 'NGN',
      sign: '₦',
      flag: 'ng',
      post: '',
      countries: [{
        name: 'Nigeria',
        flag: 'ng',
        continent: 0
      }],
      name: 'Naira'
    },
    {
      code: 'RWF',
      sign: 'FRw',
      flag: 'rw',
      post: '',
      countries: [{
        name: 'Rwanda',
        flag: 'rw',
        continent: 0
      }],
      name: 'Rwanda Franc'
    },
    {
      code: 'SHP',
      sign: '£',
      flag: 'sh',
      post: '',
      countries: [{
        name: 'Saint Helena',
        flag: 'sh',
        continent: 0
      }],
      name: 'Saint Helena Pound'
    },
    {
      code: 'STD',
      sign: 'Db',
      flag: 'st',
      post: '',
      countries: [{
        name: 'Sao Tome and Principe',
        flag: 'st',
        continent: 0
      }],
      name: 'Dobra'
    },
    {
      code: 'SCR',
      sign: '₨',
      flag: 'sc',
      post: '',
      countries: [{
        name: 'Seychelles',
        flag: 'sc',
        continent: 0
      }],
      name: 'Seychelles Rupee'
    },
    {
      code: 'SLL',
      sign: 'Le',
      flag: 'sl',
      post: '',
      countries: [{
        name: 'Sierra Leone',
        flag: 'sl',
        continent: 0
      }],
      name: 'Leone'
    },
    {
      code: 'SOS',
      sign: 'S',
      flag: 'so',
      post: '',
      countries: [{
        name: 'Somalia',
        flag: 'so',
        continent: 0
      }],
      name: 'Somali Shilling'
    },
    {
      code: 'ZAR',
      sign: 'R',
      flag: 'za',
      post: '',
      countries: [{
        name: 'South Africa',
        flag: 'za',
        continent: 0
      }],
      name: 'Rand'
    },
    {
      code: 'SZL',
      sign: 'L',
      flag: 'sz',
      post: '',
      countries: [{
        name: 'Swaziland',
        flag: 'sz',
        continent: 0
      }],
      name: 'Lilangeni'
    },
    {
      code: 'TZS',
      sign: 'TSh',
      flag: 'tz',
      post: '',
      countries: [{
        name: 'Tanzania',
        flag: 'tz',
        continent: 0
      }],
      name: 'Tanzanian Shilling'
    },
    {
      code: 'TND',
      sign: 'د.ت',
      flag: 'tn',
      post: '',
      countries: [{
        name: 'Tunisia',
        flag: 'tn',
        continent: 0
      }],
      name: 'Tunisian Dinar'
    },
    {
      code: 'UGX',
      sign: 'USh',
      flag: 'ug',
      post: '',
      countries: [{
        name: 'Uganda',
        flag: 'ug',
        continent: 0
      }],
      name: 'Uganda Shilling'
    },
    {
      code: 'ZMW',
      sign: 'ZMW',
      flag: 'zm',
      post: '',
      countries: [{
        name: 'Zambia',
        flag: 'zm',
        continent: 0
      }],
      name: 'Zambian Kwacha'
    },
    {
      code: 'BRL',
      sign: 'R$',
      flag: 'br',
      post: '',
      top: 2,
      countries: [{
        name: 'Brazil',
        flag: 'br',
        continent: 1
      }],
      name: 'Brazilian Real'
    },
    {
      code: 'CAD',
      sign: '$',
      flag: 'ca',
      post: '',
      top: 8,
      countries: [{
        name: 'Canada',
        flag: 'ca',
        continent: 1
      }],
      name: 'Canadian Dollar'
    },
    {
      code: 'USD',
      sign: '$',
      flag: 'us',
      post: '',
      top: 12,
      countries: [{
        name: 'United States',
        flag: 'us',
        continent: 1
      },
      {
        name: 'British Virgin Islands',
        flag: 'vg',
        continent: 1
      },
      {
        name: 'Ecuador',
        flag: 'ec',
        continent: 1
      },
      {
        name: 'Turks and Caicos',
        flag: 'tc',
        continent: 1
      },
      {
        name: 'Federated States of Micronesia',
        flag: 'fm',
        continent: 2
      },
      {
        name: 'Marshall Islands',
        flag: 'mh',
        continent: 2
      },
      {
        name: 'Palau',
        flag: 'pw',
        continent: 2
      },
      {
        name: 'Zimbabwe',
        flag: 'zw',
        continent: 0
      },
      {
        name: 'El Salvador',
        flag: 'sv',
        continent: 0
      }],
      name: 'US Dollar'
    },
    {
      code: 'XCD',
      sign: 'XCD',
      flag: 'xc',
      post: '',
      name: 'East Caribbean Dollar',
      countries: [{
        name: 'East Caribbean',
        flag: 'xc',
        continent: 1
      },
      {
        name: 'Anguilla',
        flag: 'ai',
        continent: 1
      },
      {
        name: 'Antigua and Barbuda',
        flag: 'ag',
        continent: 1
      },
      {
        name: 'Dominica',
        flag: 'dm',
        continent: 1
      },
      {
        name: 'Grenada',
        flag: 'gd',
        continent: 1
      },
      {
        name: 'Montserrat',
        flag: 'ms',
        continent: 1
      },
      {
        name: 'Saint Kitts and Nevis',
        flag: 'kn',
        continent: 1
      },
      {
        name: 'Saint Lucia',
        flag: 'lc',
        continent: 1
      },
      {
        name: 'Saint Vincent and the Grenadines',
        flag: 'vc',
        continent: 1
      }]
    },
    {
      code: 'ARS',
      sign: '$',
      flag: 'ar',
      post: '',
      countries: [{
        name: 'Argentina',
        flag: 'ar',
        continent: 1
      }],
      name: 'Argentine Peso'
    },
    {
      code: 'AWG',
      sign: 'ƒ',
      flag: 'aw',
      post: '',
      countries: [{
        name: 'Aruba',
        flag: 'aw',
        continent: 1
      }],
      name: 'Aruban Florin'
    },
    {
      code: 'BSD',
      sign: '$',
      flag: 'bs',
      post: '',
      countries: [{
        name: 'Bahamas',
        flag: 'bs',
        continent: 1
      }],
      name: 'Bahamian Dollar'
    },
    {
      code: 'BBD',
      sign: '$',
      flag: 'bb',
      post: '',
      countries: [{
        name: 'Barbados',
        flag: 'bb',
        continent: 1
      }],
      name: 'Barbados Dollar'
    },
    {
      code: 'BZD',
      sign: 'BZ$',
      flag: 'bz',
      post: '',
      countries: [{
        name: 'Belize',
        flag: 'bz',
        continent: 1
      }],
      name: 'Belize Dollar'
    },
    {
      code: 'BMD',
      sign: '$',
      flag: 'bm',
      post: '',
      countries: [{
        name: 'Bermuda',
        flag: 'bm',
        continent: 1
      }],
      name: 'Bermudian Dollar'
    },
    {
      code: 'BOB',
      sign: '$b',
      flag: 'bo',
      post: '',
      countries: [{
        name: 'Bolivia',
        flag: 'bo',
        continent: 1
      }],
      name: 'Boliviano'
    },
    {
      code: 'KYD',
      sign: '$',
      flag: 'ky',
      post: '',
      countries: [{
        name: 'Cayman Islands',
        flag: 'ky',
        continent: 1
      }],
      name: 'Cayman Islands Dollar'
    },
    {
      code: 'CLP',
      sign: '$',
      flag: 'cl',
      post: '',
      countries: [{
        name: 'Chile',
        flag: 'cl',
        continent: 1
      }],
      name: 'Chilean Peso'
    },
    {
      code: 'COP',
      sign: '$',
      flag: 'co',
      post: '',
      countries: [{
        name: 'Colombia',
        flag: 'co',
        continent: 1
      }],
      name: 'Colombian Peso'
    },
    {
      code: 'CRC',
      sign: '₡',
      flag: 'cr',
      post: '',
      countries: [{
        name: 'Costa Rica',
        flag: 'cr',
        continent: 1
      }],
      name: 'Costa Rican Colon'
    },
    {
      code: 'DOP',
      sign: 'RD$',
      flag: 'do',
      post: '',
      countries: [{
        name: 'Dominican Republic',
        flag: 'do',
        continent: 1
      }],
      name: 'Dominican Peso'
    },
    {
      code: 'FKP',
      sign: '£',
      flag: 'fk',
      post: '',
      countries: [{
        name: 'Falkland Islands',
        flag: 'fk',
        continent: 1
      }],
      name: 'Falkland Islands Pound'
    },
    {
      code: 'DKK',
      sign: 'DKK',
      flag: 'dk',
      post: '',
      countries: [{
        name: 'Denmark',
        flag: 'dk',
        continent: 3
      },
      {
        name: 'Greenland',
        flag: 'gl',
        continent: 1
      },
      {
        name: 'Faroe Islands',
        flag: 'fo',
        continent: 3
      }],
      name: 'Danish Krone'
    },
    {
      code: 'GTQ',
      sign: 'Q',
      flag: 'gt',
      post: '',
      countries: [{
        name: 'Guatemala',
        flag: 'gt',
        continent: 1
      }],
      name: 'Quetzal'
    },
    {
      code: 'GYD',
      sign: '$',
      flag: 'gy',
      post: '',
      countries: [{
        name: 'Guyana',
        flag: 'gy',
        continent: 1
      }],
      name: 'Guyana Dollar'
    },
    {
      code: 'HNL',
      sign: 'L',
      flag: 'hn',
      post: '',
      countries: [{
        name: 'Honduras',
        flag: 'hn',
        continent: 1
      }],
      name: 'Lempira'
    },
    {
      code: 'JMD',
      sign: 'J$',
      flag: 'jm',
      post: '',
      countries: [{
        name: 'Jamaica',
        flag: 'jm',
        continent: 1
      }],
      name: 'Jamaican Dollar'
    },
    {
      code: 'MXN',
      sign: '$',
      flag: 'mx',
      post: '',
      countries: [{
        name: 'Mexico',
        flag: 'mx',
        continent: 1
      }],
      name: 'Mexican Peso'
    },
    {
      code: 'ANG',
      sign: 'ƒ',
      flag: 'an',
      post: '',
      countries: [{
        name: 'Netherlands Antilles',
        flag: 'an',
        continent: 1
      }],
      name: 'Netherlands Antillean Guilder'
    },
    {
      code: 'NIO',
      sign: 'C$',
      flag: 'ni',
      post: '',
      countries: [{
        name: 'Nicaragua',
        flag: 'ni',
        continent: 1
      }],
      name: 'Cordoba Oro'
    },
    {
      code: 'PAB',
      sign: 'B/.',
      flag: 'pa',
      post: '',
      countries: [{
        name: 'Panama',
        flag: 'pa',
        continent: 1
      }],
      name: 'Balboa'
    },
    {
      code: 'PYG',
      sign: 'Gs',
      flag: 'py',
      post: '',
      countries: [{
        name: 'Paraguay',
        flag: 'py',
        continent: 1
      }],
      name: 'Guarani'
    },
    {
      code: 'PEN',
      sign: 'S/.',
      flag: 'pe',
      post: '',
      countries: [{
        name: 'Peru',
        flag: 'pe',
        continent: 1
      }],
      name: 'Nuevo Sol'
    },
    {
      code: 'SRD',
      sign: '$',
      flag: 'sr',
      post: '',
      countries: [{
        name: 'Suriname',
        flag: 'sr',
        continent: 1
      }],
      name: 'Surinam Dollar'
    },
    {
      code: 'TTD',
      sign: 'TT$',
      flag: 'tt',
      post: '',
      countries: [{
        name: 'Trinidad and Tobago',
        flag: 'tt',
        continent: 1
      }],
      name: 'Trinidad and Tobago Dollar'
    },
    {
      code: 'UYU',
      sign: '$U',
      flag: 'uy',
      post: '',
      countries: [{
        name: 'Uruguay',
        flag: 'uy',
        continent: 1
      }],
      name: 'Peso Uruguayo'
    },
    {
      code: 'VEF',
      sign: 'Bs',
      flag: 've',
      post: '',
      countries: [{
        name: 'Venezuela',
        flag: 've',
        continent: 1
      }],
      name: 'Bolivar'
    },
    {
      code: 'AUD',
      sign: '$',
      flag: 'au',
      post: '',
      top: 7,
      countries: [{
        name: 'Australia',
        flag: 'au',
        continent: 2
      },
      {
        name: 'Kiribati',
        flag: 'ki',
        continent: 2
      },
      {
        name: 'Nauru',
        flag: 'nr',
        continent: 2
      },
      {
        name: 'Norfolk Island',
        flag: 'nf',
        continent: 2
      }],
      name: 'Australian Dollar'
    },
    {
      code: 'CNY',
      sign: '¥',
      flag: 'cn',
      post: '',
      top: 6,
      countries: [{
        name: 'China',
        flag: 'cn',
        continent: 2
      }],
      name: 'Yuan Renminbi'
    },
    {
      code: 'HKD',
      sign: '$',
      flag: 'hk',
      post: '',
      top: 4,
      countries: [{
        name: 'Hong Kong',
        flag: 'hk',
        continent: 2
      }],
      name: 'Hong Kong Dollar'
    },
    {
      code: 'INR',
      sign: '₹',
      flag: 'in',
      post: '',
      top: 3,
      countries: [{
        name: 'India',
        flag: 'in',
        continent: 2
      }],
      name: 'Indian Rupee'
    },
    {
      code: 'BDT',
      sign: '৳',
      flag: 'bd',
      post: '',
      countries: [{
        name: 'Bangladesh',
        flag: 'bd',
        continent: 2
      }],
      name: 'Bangladeshi taka'
    },
    {
      code: 'JPY',
      sign: '¥',
      flag: 'jp',
      post: '',
      top: 9,
      name: 'Japanese Yen',
      countries: [{
        name: 'Japan',
        flag: 'jp',
        continent: 2
      }]
    },
    {
      code: 'SGD',
      sign: '$',
      flag: 'sg',
      post: '',
      top: 1,
      countries: [{
        name: 'Singapore',
        flag: 'sg',
        continent: 2
      }],
      name: 'Singapore Dollar'
    },
    {
      code: 'AMD',
      sign: 'AMD',
      flag: 'am',
      post: 'dram',
      countries: [{
        name: 'Armenia',
        flag: 'am',
        continent: 2
      }],
      name: 'Armenian Dram'
    },
    {
      code: 'BHD',
      sign: '.د.ب',
      flag: 'bh',
      post: '',
      countries: [{
        name: 'Bahrain',
        flag: 'bh',
        continent: 2
      }],
      name: 'Bahraini Dinar'
    },
    {
      code: 'BTN',
      sign: 'Nu',
      flag: 'bt',
      post: '',
      countries: [{
        name: 'Bhutan',
        flag: 'bt',
        continent: 2
      }],
      name: 'Ngultrum'
    },
    {
      code: 'BND',
      sign: '$',
      flag: 'bn',
      post: '',
      countries: [{
        name: 'Brunei',
        flag: 'bn',
        continent: 2
      }],
      name: 'Brunei Dollar'
    },
    {
      code: 'KHR',
      sign: '៛',
      flag: 'kh',
      post: '',
      countries: [{
        name: 'Cambodia',
        flag: 'kh',
        continent: 2
      }],
      name: 'Riel'
    },
    {
      code: 'NZD',
      sign: 'NZD',
      flag: 'nz',
      post: '',
      name: 'New Zealand Dollar',
      countries: [{
        name: 'New Zealand',
        flag: 'nz',
        continent: 2
      },
      {
        name: 'Cook Islands',
        flag: 'ck',
        continent: 2
      },
      {
        name: 'Niue',
        flag: 'nu',
        continent: 2
      },
      {
        name: 'Pitcairn Islands',
        flag: 'pn',
        continent: 2
      }]
    },
    {
      code: 'FJD',
      sign: '$',
      flag: 'fj',
      post: '',
      countries: [{
        name: 'Fiji',
        flag: 'fj',
        continent: 2
      }],
      name: 'Fiji Dollar'
    },
    {
      code: 'XPF',
      sign: 'F',
      flag: 'pf',
      post: '',
      countries: [{
        name: 'French Polynesia',
        flag: 'pf',
        continent: 2
      },
      {
        name: 'New Caledonia',
        flag: 'nc',
        continent: 2
      },
      {
        name: 'Wallis and Futuna',
        flag: 'wf',
        continent: 2
      }],
      name: 'CFP Franc'
    },
    {
      code: 'IDR',
      sign: 'Rp',
      flag: 'id',
      post: '',
      countries: [{
        name: 'Indonesia',
        flag: 'id',
        continent: 2
      }],
      name: 'Rupiah'
    },
    {
      code: 'ILS',
      sign: '₪',
      flag: 'il',
      post: '',
      countries: [{
        name: 'Israel',
        flag: 'il',
        continent: 2
      }],
      name: 'New Israeli Sheqel'
    },
    {
      code: 'JOD',
      sign: 'JOD',
      flag: 'jo',
      post: '',
      countries: [{
        name: 'Jordan',
        flag: 'jo',
        continent: 2
      }],
      name: 'Jordanian Dinar'
    },
    {
      code: 'KZT',
      sign: 'лв',
      flag: 'kz',
      post: '',
      countries: [{
        name: 'Kazakhstan',
        flag: 'kz',
        continent: 2
      }],
      name: 'Tenge'
    },
    {
      code: 'KWD',
      sign: 'د.ك',
      flag: 'kw',
      post: '',
      countries: [{
        name: 'Kuwait',
        flag: 'kw',
        continent: 2
      }],
      name: 'Kuwaiti Dinar'
    },
    {
      code: 'KGS',
      sign: 'лв',
      flag: 'kg',
      post: '',
      countries: [{
        name: 'Kyrgyzstan',
        flag: 'kg',
        continent: 2
      }],
      name: 'Som'
    },
    {
      code: 'LAK',
      sign: '₭',
      flag: 'la',
      post: '',
      countries: [{
        name: 'Laos',
        flag: 'la',
        continent: 2
      }],
      name: 'Kip'
    },
    {
      code: 'MYR',
      sign: 'RM',
      flag: 'my',
      post: '',
      countries: [{
        name: 'Malaysia',
        flag: 'my',
        continent: 2
      }],
      name: 'Malaysian Ringgit'
    },
    {
      code: 'MVR',
      sign: 'Rf',
      flag: 'mv',
      post: '',
      countries: [{
        name: 'Maldives',
        flag: 'mv',
        continent: 2
      }],
      name: 'Rufiyaa'
    },
    {
      code: 'AFN',
      sign: '؋',
      flag: 'af',
      post: '',
      countries: [{
        name: 'Afghanistan',
        flag: 'af',
        continent: 2
      }],
      name: 'Afghani'
    },
    {
      code: 'LBP',
      sign: 'ل.ل',
      flag: 'lb',
      post: '',
      countries: [{
        name: 'Lebanon',
        flag: 'lb',
        continent: 2
      }],
      name: 'Lebanese Pound'
    },
    {
      code: 'LRD',
      sign: '$',
      flag: 'lr',
      post: '',
      countries: [{
        name: 'Liberia',
        flag: 'lr',
        continent: 2
      }],
      name: 'Liberian Dollar'
    },
    {
      code: 'CUP',
      sign: '₱',
      flag: 'cu',
      post: '',
      countries: [{
        name: 'Cuba',
        flag: 'cu',
        continent: 1
      }],
      name: 'Cuban Peso'
    },
    {
      code: 'KPW',
      sign: '₩',
      flag: 'kp',
      post: '',
      countries: [{
        name: 'Korea (North)',
        flag: 'kp',
        continent: 2
      }],
      name: 'North Korean Won'
    },
    {
      code: 'SYP',
      sign: '£',
      flag: 'sy',
      post: '',
      countries: [{
        name: 'Syrian',
        flag: 'sy',
        continent: 2
      }],
      name: 'Syrian Pound'
    },
    {
      code: 'MNT',
      sign: '₮',
      flag: 'mn',
      post: '',
      countries: [{
        name: 'Mongolia',
        flag: 'mn',
        continent: 2
      }],
      name: 'Tugrik'
    },
    {
      code: 'UZS',
      sign: 'лв',
      flag: 'uz',
      post: '',
      countries: [{
        name: 'Uzbekistan',
        flag: 'uz',
        continent: 2
      }],
      name: 'Uzbekistan Sum'
    },
    {
      code: 'PKR',
      sign: '₨',
      flag: 'pk',
      post: '',
      countries: [{
        name: 'Pakistan',
        flag: 'pk',
        continent: 2
      }],
      name: 'Pakistan Rupee'
    },
    {
      code: 'BTC',
      sign: 'BTC ',
      flag: 'btc',
      post: '',
      isHidden: true,
      countries: [],
      name: 'Bitcoin'
    },
    {
      code: 'IRR',
      sign: '﷼',
      flag: 'ir',
      post: '',
      name: 'Iranian Rial',
      countries: [{
        name: 'Iran',
        flag: 'ir',
        continent: 2
      }]
    },
    {
      code: 'NPR',
      sign: '₨',
      flag: 'np',
      post: '',
      countries: [{
        name: 'Nepal',
        flag: 'np',
        continent: 2
      }],
      name: 'Nepalese Rupee'
    },
    {
      code: 'OMR',
      sign: '﷼',
      flag: 'om',
      post: '',
      countries: [{
        name: 'Oman',
        flag: 'om',
        continent: 2
      }],
      name: 'Rial Omani'
    },
    {
      code: 'PGK',
      sign: 'K',
      flag: 'pg',
      post: '',
      countries: [{
        name: 'Papua New Guinea',
        flag: 'pg',
        continent: 2
      }],
      name: 'Kina'
    },
    {
      code: 'PHP',
      sign: '₱',
      flag: 'ph',
      post: '',
      countries: [{
        name: 'Philippines',
        flag: 'ph',
        continent: 2
      }],
      name: 'Philippine Peso'
    },
    {
      code: 'QAR',
      sign: '﷼',
      flag: 'qa',
      post: '',
      countries: [{
        name: 'Qatar',
        flag: 'qa',
        continent: 2
      }],
      name: 'Qatari Rial'
    },
    {
      code: 'WST',
      sign: 'WS$',
      flag: 'ws',
      post: '',
      countries: [{
        name: 'Samoa',
        flag: 'ws',
        continent: 2
      }],
      name: 'Tala'
    },
    {
      code: 'SAR',
      sign: '﷼',
      flag: 'sa',
      post: '',
      countries: [{
        name: 'Saudi Arabia',
        flag: 'sa',
        continent: 2
      }],
      name: 'Saudi Riyal'
    },
    {
      code: 'SBD',
      sign: '$',
      flag: 'sb',
      post: '',
      countries: [{
        name: 'Solomon Islands',
        flag: 'sb',
        continent: 2
      }],
      name: 'Solomon Islands Dollar'
    },
    {
      code: 'KRW',
      sign: '₩',
      flag: 'kr',
      post: '',
      countries: [{
        name: 'South Korea',
        flag: 'kr',
        continent: 2
      }],
      name: 'Won'
    },
    {
      code: 'LKR',
      sign: '₨',
      flag: 'lk',
      post: '',
      countries: [{
        name: 'Sri Lanka',
        flag: 'lk',
        continent: 2
      }],
      name: 'Sri Lanka Rupee'
    },
    {
      code: 'TWD',
      sign: 'NT$',
      flag: 'tw',
      post: '',
      countries: [{
        name: 'Taiwan',
        flag: 'tw',
        continent: 2
      }],
      name: 'New Taiwan Dollar'
    },
    {
      code: 'TJS',
      sign: 'TJS',
      flag: 'tj',
      post: '',
      countries: [{
        name: 'Tajikistan',
        flag: 'tj',
        continent: 2
      }],
      name: 'Somoni'
    },
    {
      code: 'THB',
      sign: '฿',
      flag: 'th',
      post: '',
      countries: [{
        name: 'Thailand',
        flag: 'th',
        continent: 2
      }],
      name: 'Baht'
    },
    {
      code: 'TOP',
      sign: 'T$',
      flag: 'to',
      post: '',
      countries: [{
        name: 'Tonga',
        flag: 'to',
        continent: 2
      }],
      name: 'Pa\'anga'
    },
    {
      code: 'TMT',
      sign: 'T',
      flag: 'tm',
      post: '',
      countries: [{
        name: 'Turkmenistan',
        flag: 'tm',
        continent: 2
      }],
      name: 'Turkmenistan New Manat'
    },
    {
      code: 'AED',
      sign: 'د.إ',
      flag: 'ae',
      post: '',
      countries: [{
        name: 'United Arab Emirates',
        flag: 'ae',
        continent: 2
      }],
      name: 'UAE Dirham'
    },
    {
      code: 'VUV',
      sign: 'VT',
      flag: 'vu',
      post: '',
      countries: [{
        name: 'Vanuatu',
        flag: 'vu',
        continent: 2
      }],
      name: 'Vatu'
    },
    {
      code: 'VND',
      sign: '₫',
      flag: 'vn',
      post: '',
      countries: [{
        name: 'Vietnam',
        flag: 'vn',
        continent: 2
      }],
      name: 'Dong'
    },
    {
      code: 'YER',
      sign: '﷼',
      flag: 'ye',
      post: '',
      countries: [{
        name: 'Yemen',
        flag: 'ye',
        continent: 2
      }],
      name: 'Yemeni Rial'
    },
    {
      code: 'CHF',
      sign: 'CHF',
      flag: 'ch',
      post: '',
      top: 5,
      name: 'Swiss Franc',
      countries: [{
        name: 'Switzerland',
        flag: 'ch',
        continent: 3
      },
      {
        name: 'Liechtenstein',
        flag: 'li',
        continent: 3
      }]
    },
    {
      code: 'GBP',
      sign: '£',
      flag: 'gb',
      post: '',
      top: 10,
      countries: [{
        name: 'United Kingdom',
        flag: 'gb',
        continent: 3
      }],
      name: 'Pound Sterling'
    },
    {
      code: 'ALL',
      sign: 'Lek',
      flag: 'al',
      post: '',
      countries: [{
        name: 'Albania',
        flag: 'al',
        continent: 3
      }],
      name: 'Lek'
    },
    {
      code: 'AZN',
      sign: 'ман',
      flag: 'az',
      post: '',
      countries: [{
        name: 'Azerbaijan Republic',
        flag: 'az',
        continent: 3
      }],
      name: 'Azerbaijanian Manat'
    },
    {
      code: 'BYR',
      sign: 'p.',
      flag: 'by',
      post: '',
      countries: [{
        name: 'Belarus',
        flag: 'by',
        continent: 3
      }],
      name: 'Belarusian Ruble'
    },
    {
      code: 'BAM',
      sign: 'KM',
      flag: 'ba',
      post: '',
      countries: [{
        name: 'Bosnia and Herzegovina',
        flag: 'ba',
        continent: 3
      }],
      name: 'Convertible Mark'
    },
    {
      code: 'BGN',
      sign: 'лв',
      flag: 'bg',
      post: '',
      countries: [{
        name: 'Bulgaria',
        flag: 'bg',
        continent: 3
      }],
      name: 'Bulgarian Lev'
    },
    {
      code: 'HRK',
      sign: 'kn',
      flag: 'hr',
      post: '',
      countries: [{
        name: 'Croatia',
        flag: 'hr',
        continent: 3
      }],
      name: 'Kuna'
    },
    {
      code: 'CZK',
      sign: 'Kč',
      flag: 'cz',
      post: '',
      countries: [{
        name: 'Czech Republic',
        flag: 'cz',
        continent: 3
      }],
      name: 'Czech Koruna'
    },
    {
      code: 'GEL',
      sign: 'GEL',
      flag: 'ge',
      post: 'lari',
      countries: [{
        name: 'Georgia',
        flag: 'ge',
        continent: 3
      }],
      name: 'Lari'
    },
    {
      code: 'GIP',
      sign: '£',
      flag: 'gi',
      post: '',
      countries: [{
        name: 'Gibraltar',
        flag: 'gi',
        continent: 3
      }],
      name: 'Gibraltar Pound'
    },
    {
      code: 'HUF',
      sign: 'Ft',
      flag: 'hu',
      post: '',
      countries: [{
        name: 'Hungary',
        flag: 'hu',
        continent: 3
      }],
      name: 'Forint'
    },
    {
      code: 'ISK',
      sign: 'kr',
      flag: 'is',
      post: '',
      countries: [{
        name: 'Iceland',
        flag: 'is',
        continent: 3
      }],
      name: 'Iceland Krona'
    },
    {
      code: 'MKD',
      sign: 'ден',
      flag: 'mk',
      post: '',
      countries: [{
        name: 'Macedonia',
        flag: 'mk',
        continent: 3
      }],
      name: 'Denar'
    },
    {
      code: 'MDL',
      sign: 'MDL',
      flag: 'md',
      post: '',
      countries: [{
        name: 'Moldova',
        flag: 'md',
        continent: 3
      }],
      name: 'Moldovan Leu'
    },
    {
      code: 'NOK',
      sign: 'kr',
      flag: 'no',
      post: '',
      countries: [{
        name: 'Norway',
        flag: 'no',
        continent: 3
      },
      {
        name: 'Svalbard and Jan Mayen',
        flag: 'sj',
        continent: 3
      }],
      name: 'Norwegian Krone'
    },
    {
      code: 'PLN',
      sign: 'zł',
      flag: 'pl',
      post: '',
      countries: [{
        name: 'Poland',
        flag: 'pl',
        continent: 3
      }],
      name: 'Zloty'
    },
    {
      code: 'RON',
      sign: 'lei',
      flag: 'ro',
      post: '',
      countries: [{
        name: 'Romania',
        flag: 'ro',
        continent: 3
      }],
      name: 'Romanian Leu'
    },
    {
      code: 'RUB',
      sign: '₽',
      flag: 'ru',
      post: '',
      countries: [{
        name: 'Russia',
        flag: 'ru',
        continent: 3
      }],
      name: 'Russian Ruble'
    },
    {
      code: 'RSD',
      sign: 'Дин.',
      flag: 'rs',
      post: '',
      countries: [{
        name: 'Serbia',
        flag: 'rs',
        continent: 3
      }],
      name: 'Serbian Dinar'
    },
    {
      code: 'SEK',
      sign: 'kr',
      flag: 'se',
      post: '',
      countries: [{
        name: 'Sweden',
        flag: 'se',
        continent: 3
      }],
      name: 'Swedish Krona'
    },
    {
      code: 'TRY',
      sign: '₺',
      flag: 'tr',
      post: 'lira',
      countries: [{
        name: 'Turkey',
        flag: 'tr',
        continent: 3
      }],
      name: 'Turkish Lira'
    },
    {
      code: 'UAH',
      sign: '₴',
      flag: 'ua',
      post: '',
      countries: [{
        name: 'Ukraine',
        flag: 'ua',
        continent: 3
      }],
      name: 'Hryvnia'
    }]);
})();
